import { AgentApi } from 'src/Services/API/Agent.api';
import { AnnouncementApi } from 'src/Services/API/Announcement.api';
import { BudgetBreakdownApi } from 'src/Services/API/BudgetBreakdown.api';
import { BudgetForecastViewApi } from 'src/Services/API/BudgetForecastView.api';
import { BudgetSimulationApi } from 'src/Services/API/BudgetSimulation.api';
import { CartographyApi } from 'src/Services/API/Cartography.api';
import { ChecklistTemplateApi } from 'src/Services/API/ChecklistTemplate.api';
import { CustomConfiguration } from 'src/Services/API/customConfiguration';
import { EntityLinksApi } from 'src/Services/API/EntityLinks.api';
import { GovernanceApi } from 'src/Services/API/Governance.api';
import { HouseholdsApi } from 'src/Services/API/Households.api';
import { MemoriesApi } from 'src/Services/API/Memories.api';
import { MoneyTransferApi } from 'src/Services/API/MoneyTransfer.api';
import { ProjectExtendedApi } from 'src/Services/API/Project.api';
import { TaskApi } from 'src/Services/API/Task.api';

import {
  AssetsApi,
  AuthenticationApi,
  BudgetApi,
  FundCallsApi,
  BudgetForecastApi,
  ContactsApi,
  CountriesApi,
  DashboardApi,
  UserApi,
  EventsApi,
  InstructionsApi,
  PracticalInformationApi,
  InviteCodesApi,
  InvitationsApi,
  AssetMembershipApi,
  VersionApi,
  EntityExportsApi,
  PublicExportsApi,
  AssetStorageApi,
  ChecklistsApi,
  ChecklistSubmissionsApi,
  ExpensesApi,
  AddressesApi,
  VideosApi,
  CommunityApi,
  WeatherApi,
  CommunityFeedApi,
  BankAccountsApi,
  ProjectsApi,
  PhotoTagsApi,
  PlaceholderMembersApi,
  InitialBalancesApi,
  MemberRemindersApi,
  DocumentSuggestionsApi,
  InventoryApi,
} from './generated/api';

const configuration = new CustomConfiguration({
  basePath: import.meta.env.VITE_API_URL,
  transformResponse: true,
});

export const userApi = new UserApi(configuration);
export const assetsApi = new AssetsApi(configuration);
export const contactsApi = new ContactsApi(configuration);
export const eventsApi = new EventsApi(configuration);
export const countriesApi = new CountriesApi(configuration);
export const authApi = new AuthenticationApi(configuration);
export const instructionsApi = new InstructionsApi(configuration);
export const practicalInformationApi = new PracticalInformationApi(configuration);
export const inviteCodesApi = new InviteCodesApi(configuration);
export const invitationsApi = new InvitationsApi(configuration);
export const assetMembershipApi = new AssetMembershipApi(configuration);
export const versionApi = new VersionApi(configuration);
export const entityExportsApi = new EntityExportsApi(configuration);
export const publicExportsApi = new PublicExportsApi(configuration);
export const assetStorageApi = new AssetStorageApi(configuration);
export const checklistsApi = new ChecklistsApi(configuration);
export const checklistSubmissionApi = new ChecklistSubmissionsApi(configuration);
export const expensesApi = new ExpensesApi(configuration);
export const addressesApi = new AddressesApi(configuration);
export const videosApi = new VideosApi(configuration);
export const communityApi = new CommunityApi(configuration);
export const communityFeedApi = new CommunityFeedApi(configuration);
export const weatherApi = new WeatherApi(configuration);
export const projectExtendedApi = new ProjectExtendedApi(configuration);
export const bankAccountsApi = new BankAccountsApi(configuration);
export const moneyTransferApi = new MoneyTransferApi(configuration);
export const projectsApi = new ProjectsApi(configuration);
export const photoTagsApi = new PhotoTagsApi(configuration);
export const dashboardApi = new DashboardApi(configuration);
export const taskApi = new TaskApi(configuration);
export const governanceApi = new GovernanceApi(configuration);
export const householdsApi = new HouseholdsApi(configuration);
export const announcementApi = new AnnouncementApi(configuration);
export const budgetApi = new BudgetApi(configuration);
export const fundCallsApi = new FundCallsApi(configuration);
export const budgetForecastApi = new BudgetForecastApi(configuration);
export const budgetForecastViewApi = new BudgetForecastViewApi(configuration);
export const budgetBreakdownApi = new BudgetBreakdownApi(configuration);
export const budgetSimulationApi = new BudgetSimulationApi(configuration);
export const cartographyApi = new CartographyApi(configuration);
export const checklistTemplateApi = new ChecklistTemplateApi(configuration);
export const placeholderMembersApi = new PlaceholderMembersApi(configuration);
export const entityLinksApi = new EntityLinksApi(configuration);
export const memoriesApi = new MemoriesApi(configuration);
export const agentApi = new AgentApi(configuration);
export const initialBalancesApi = new InitialBalancesApi(configuration);
export const memberRemindersApi = new MemberRemindersApi(configuration);
export const documentSuggestionsApi = new DocumentSuggestionsApi(configuration);
export const inventoryApi = new InventoryApi(configuration);
